import { api } from "../adapters/api"

const resource = "api/v1/credits"
const auth = () => ({ "Authorization": "Bearer " + localStorage.getItem("jwtToken") })

export const getCreditBalance = () =>
  api.get(resource + "/balance", auth()).then((r: any) => r.json())

export const getCreditTransactions = (page = 0, size = 20) =>
  api.get(resource + "/transactions?page=" + page + "&size=" + size, auth()).then((r: any) => r.json())

export const getCreditPackages = () =>
  api.get(resource + "/packages", auth()).then((r: any) => r.json())

export const getCreditPricing = () =>
  api.get(resource + "/pricing", auth()).then((r: any) => r.json())

export const createCreditCheckout = (packageName: string) =>
  api.post(resource + "/checkout?package=" + packageName, null, auth()).then((r: any) => r.json())
